import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-aboutinfo",
  "use": "icon-aboutinfo-usage",
  "viewBox": "0 0 1025 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1025 1024\" id=\"icon-aboutinfo\"><defs><style type=\"text/css\"></style></defs><path d=\"M768.512 256l-128 0c-35.392 0-64 28.608-64 64 0 35.328 28.608 64 64 64l128 0c70.656 0 128 57.344 128 128s-57.344 128-128 128l-128 0c-35.392 0-64 28.608-64 64s28.608 64 64 64l128 0c141.376 0 256-114.624 256-256S909.888 256 768.512 256zM384.512 640l-128 0c-70.656 0-128-57.344-128-128s57.344-128 128-128l128 0c35.392 0 64-28.672 64-64 0-35.392-28.608-64-64-64l-128 0c-141.376 0-256 114.624-256 256s114.624 256 256 256l128 0c35.392 0 64-28.608 64-64S419.904 640 384.512 640zM320.512 512c0 35.392 28.608 64 64 64l256 0c35.392 0 64-28.608 64-64s-28.608-64-64-64l-256 0C349.12 448 320.512 476.608 320.512 512z\" p-id=\"109290\" fill=\"#bfbfbf\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/aboutinfo.svg
// module id = f48d
// module chunks = 22